import React from 'react';
import { Link, Typography } from '@bb-ui/react-library';

import { Grid } from '@material-ui/core';
import { useStyles } from '../ErrorPages.styles';
import { useApplicationTitle } from '../../../hooks/useApplicationTitle';
import { useHelpLinks } from '../../../hooks/useHelpLinks';

export const BrowserIncompatibilityErrorPage: React.FunctionComponent = () => {
    const classes = useStyles();
    const getHelpLink = useHelpLinks();

    // This does not get localized
    useApplicationTitle('Browser is not supported');

    return (
        <Grid
            className={classes.pageContainer}
            data-testid="browser-incompatibility-error-page-container"
            container
            alignItems="center"
            justifyContent="center"
        >
            <img
                // eslint-disable-next-line @typescript-eslint/no-require-imports
                src={require('../../../../app/assets/images/copy/ErrorPages/browserIncompatibilityIllustration.svg')}
                alt=""
                className={classes.illustration}
            />
            <Typography
                data-testid="browser-incompatibility-title"
                variant="h1"
                align="center"
            >
                We noticed the browser you're using isn't supported.
            </Typography>
            <Typography className={classes.text} align="center">
                You can switch to a&nbsp;
                <Link
                    href="https://help.anthology.com/illuminate/en/get-started/supported-browsers.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="browsers-compatible-link"
                >
                    browser Blackboard Illuminate supports
                </Link>
                &nbsp;to access it.
            </Typography>
            <Typography className={classes.text} align="center">
                If the problem continues, have your administrator&nbsp;
                <Link
                    href={getHelpLink('contactSupport')}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="support-case-link"
                >
                    contact Support
                </Link>
                .
            </Typography>
        </Grid>
    );
};
